import React from "react";
import { DatePicker, Space } from "antd";
import dayjs from "dayjs";
import "./CustomDatePickerOne.css";
import Colors from "../../../../Constants/Colors";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const CustomDatePickerOne = ({
  status = null,
  placeholder = "Select Date",
  dateFormat = "DD MMM YYYY",
  selected = null,
  onChange,
  minDate = null,
  maxDate = null,
  allowClear = true,
  disabled = false,
  suffixIcon = (
    <CalendarMonthIcon sx={{ color: Colors.primary, fontSize: 22 }} />
  ),
  type,
  ...rest
}) => {
  const handleDateChange = (date) => {
    if (onChange) {
      onChange(date ? dayjs(date).toDate() : null);
    }
  };

  return (
    <Space
      direction="vertical"
      style={{
        width: "100%",
      }}
    >
      <DatePicker
        status={status}
        suffixIcon={type === "meeting" ? null : suffixIcon}
        // defaultValue={selected ? dayjs(selected) : null}
        value={selected ? dayjs(selected) : null}
        onChange={handleDateChange}
        format={dateFormat}
        placeholder={placeholder}
        allowClear={allowClear}
        disabled={disabled}
        // disabledDate={(current) => {
        //   if (minDate && current < dayjs(minDate)) return true;
        //   if (maxDate && current > dayjs(maxDate)) return true;
        //   return false;
        // }}
        {...rest}
        className="custum-date-picker-one"
        popupClassName="custum-date-picker-one-popup"
        minDate={minDate}
        disabledDate={(current) => {
          if (!current) return false;

          return type === "meeting"
            ? current && current < dayjs().startOf("day")
            : false;
        }}
      />
    </Space>
  );
};

export default CustomDatePickerOne;
